var utility = function(){

  this.getParameterByName= function(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
      results = regex.exec(location.search);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
  }

  this.getEnvironment = function(){
    this.env = this.getParameterByName('env') || window.location.hostname;
    if (this.env === 'localhost' || this.env.indexOf('local') > -1 )
      envStr = "local";
    else
    {
      // var envStr = this.env.substring(0,4);
      var envStr = window.location.hostname.split('.')[0];
      envStr = envStr.replace('static', 'www');
      if(envStr.indexOf('fast') > 0){
        envStr = envStr.replace('fast', 'www');
      }

    }

    return envStr;
  }

  this.getPlatform = function(){
    var platform = '';
    if (navigator.userAgent.match(/Tablet|iPad/i)){
      platform = 'tweb';
    }else if(navigator.userAgent.match(/IEMobile|Windows Phone|Lumia|Android|webOS|iPhone|iPod|Blackberry|PlayBook|BB10|Mobile Safari|Opera Mini|\bCrMo\/|Opera Mobi/i)){
      platform = 'mweb';
      // if(cvsUtility.queryMap.mobileAppStyle==true || cvsUtility.queryMap.mobileAppStyle=="true") {
      //   platform = 'mapp';
      // }else{
      //   platform = 'mweb';
      // }
    } else {
      platform = 'dweb';
    }
    return platform;
  }

  this.utagUrl = function (ifWebtrends) {
    var env, url;
    switch (this.getEnvironment()) {
      case 'dev1':
      case 'dev2':
      case 'dev3':
        env = 'dev';
        break;
      case 'stp':
      case 'sit1':
      case 'sit2':
      case 'sit3':
        env = 'qa';
        break;
      case 'prod':
      case 'www':
        env = 'prod';
        break;
      case 'local':
        env = 'qa';
        break;
      default:
        env = 'dev';
    }
    if(ifWebtrends){
      return env;
    }
    return (url) ? url : '//tags.tiqcdn.com/utag/cvs/cvscaremarkspecialtyrx/' + env + '/utag.js';
  };

}

var cvsJSUtility = new utility();


(function(a,b,c,d){
  a=cvsJSUtility.utagUrl();
  b=document;c='script';d=b.createElement(c);d.src=a;d.type='text/java'+c;d.async=true;
  a=b.getElementsByTagName(c)[0];a.parentNode.insertBefore(d,a);
})();


